import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";

import { dispatchNotification } from "@/modules/common/utils/notifications";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    meta: {
      layout: "main",
      requiresAuth: true,
    },
    component: () => import("@/modules/home/pages/HomePage.vue"),
  },
  {
    path: "/signin/callback",
    name: "yandexCallback",
    component: () => import("@/modules/auth/pages/YandexCallback.vue"),
  },
  {
    path: "/signin/",
    name: "signin",
    meta: {
      layout: "empty",
      requiresAuth: false,
    },
    component: () => import("@/modules/auth/pages/SignInPage.vue"),
    beforeEnter(from, to, next) {
      if (store.getters["auth/IS_LOGIN"]) {
        next({ name: "home" });
      } else {
        next();
      }
    },
  },
  {
    path: "/reports/",
    name: "reports",
    meta: {
      layout: "main",
      requiresAuth: true,
    },
    component: () => import("@/modules/reports/pages/ReportsPage.vue"),
  },
  {
    path: "/forge",
    name: "forge",
    meta: {
      layout: "main",
      requiresAuth: true,
    },
    component: () => import("@/modules/forge/pages/ForgePage.vue"),
  },
  // Must be the last in the list of routes
  {
    path: "/:any(.*)",
    meta: {
      layout: "main",
      requiresAuth: true,
    },
    component: () => import("@/modules/common/pages/E404Page.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (store.getters["auth/IS_LOGIN"]) {
      next();
    } else {
      store.dispatch("auth/SIGN_OUT");
      next({ name: "signin" });
    }
  } else {
    next();
  }
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.accessPermissions !== undefined && to.meta.accessPermissions) {
    // Обновляем данные и пермишены пользователя
    await store.dispatch("users/FETCH_USER_ME_WITH_PERMISSIONS");

    next();
  } else {
    next();
  }
});

export default router;
